import React from 'react';

const CheckmarkLabel = () => (
<svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.2019 0.949382C18.9692 0.182085 20.2132 0.182085 20.9805 0.949382C21.7384 1.70727 21.7477 2.93028 21.0084 3.69957L10.55 16.7726C10.5349 16.7915 10.5187 16.8095 10.5017 16.8266C9.73436 17.5939 8.49033 17.5939 7.72303 16.8266L0.790074 9.89367C0.0227749 9.12637 0.022775 7.88233 0.790074 7.11504C1.55737 6.34774 2.80141 6.34774 3.56871 7.11504L9.05315 12.5995L18.1498 1.00816C18.166 0.987539 18.1834 0.967913 18.2019 0.949382Z" fill="#141414"/>
</svg>
);

export default CheckmarkLabel;